export default __webpack_public_path__ + "rar_edit.html";